module.exports = __webpack_public_path__ + "img/report_card.3cc47361.png";